"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPEventRecordCreated = void 0;
const event_manager_1 = require("../../../event_manager");
const store_1 = require("../../../exports/store");
const types_1 = require("../../../types");
const helper_1 = require("../../helper");
const interface_1 = require("../interface");
const const_1 = require("./../../const");
class OPEventRecordCreated extends interface_1.IAtomEventType {
    constructor() {
        super(...arguments);
        this.eventName = const_1.OPEventNameEnums.RecordCreated;
        this.realType = const_1.EventRealTypeEnums.REAL;
        this.scope = types_1.ResourceType.Datasheet;
    }
    test({ action, resourceId, op }) {
        const { pass, recordId } = (0, event_manager_1.testPath)(action.p, ['recordMap', ':recordId'], ('oi' in action));
        if (!pass) {
            return {
                pass: false,
                context: null
            };
        }
        // fill phase will overwrite diffFields
        const diffFields = Object.keys(action['oi'].data);
        return {
            pass,
            context: {
                datasheetId: resourceId,
                recordId,
                op,
                fields: action['oi'].data,
                diffFields
            }
        };
    }
    /**
     * Complete event context
     */
    fill(events, state) {
        return events.map(event => {
            var _a;
            if (event.eventName === const_1.OPEventNameEnums.RecordCreated) {
                const { datasheetId, recordId } = event.context;
                const fieldMap = store_1.Selectors.getFieldMap(state, datasheetId);
                const fieldKeys = Object.keys(fieldMap);
                event.context.datasheetName = (_a = store_1.Selectors.getDatasheet(state, datasheetId)) === null || _a === void 0 ? void 0 : _a.name;
                event.context.state = state;
                const { fields, eventFields } = (0, helper_1.transformOpFields)({
                    recordData: event.context.fields,
                    state: state,
                    datasheetId,
                    recordId,
                });
                event.context.eventFields = eventFields;
                event.context.fields = fields;
                // When a new record is added, all fields are changed from scratch. This diffFields should contain all fields.
                event.context.diffFields = fieldKeys;
            }
            return event;
        });
    }
}
exports.OPEventRecordCreated = OPEventRecordCreated;
//# sourceMappingURL=record_created.js.map